import {isDynamoChildrenBinding} from '@packages/systems/dynamo/wfdl';
import {Expressions} from '@packages/systems/wfdl';
import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {
  isAllowedTypographic,
  isBackgroundVideoElement,
  isBindBoundElement,
  isTypographicElement,
} from '@packages/utilities/elementTypeUtils';
import {getChildren} from '@packages/utilities/platform';

type IsTypographicCandidateOptions = {
  allowTypographicConversion?: boolean;
};

export const isTypographicCandidate = (
  element: ExpressionElement,
  {allowTypographicConversion = true}: IsTypographicCandidateOptions = {}
) => {
  if (!allowTypographicConversion) {
    return false;
  }

  // Only allow specific tags to become typographic
  if (!isAllowedTypographic(element)) {
    return false;
  }

  // If already a typographic block, no longer a candidate...
  if (isTypographicElement(element)) {
    return false;
  }

  // bound dynamic nodes cannot be typographic candidates
  if (isDynamoChildrenBinding(element.data) || isBindBoundElement(element)) {
    return false;
  }

  // Don't allow any element with grid data
  if (
    Expressions.getElementDataAt(
      element,
      [
        {in: 'Record', at: 'grid'},
        {in: 'Record', at: 'type'},
      ],
      'Text',
      ''
    )
  ) {
    return false;
  }

  // Don't allow any element with background video data
  if (isBackgroundVideoElement(element)) {
    return false;
  }

  const children = getChildren(element);

  // If the node is completely empty, it can be converted to a typographic node
  if (children && children.length === 0) {
    return true;
  }

  return false;
};
